import type { JobTitleI, JobTitleFilterI, FetchResponseI } from 'types';
import { BaseApi } from './base-api';
import { fetchData } from 'Utils/fetch-data';

export interface AvailableCourseI {
  id: string;
  name: string;
  duration: number | null;
}

export interface BulkAssignCoursesPayload {
  jobTitleIds: string[];
  courseIds: string[];
}

class JobTitlesApi extends BaseApi<JobTitleI, JobTitleFilterI> {
  async patch(id: string, data: { status: boolean }) {
    const response = await fetchData<{ status: boolean }>(`${this.endpoint}/${id}`, {
      method: 'PATCH',
      data,
    });
    return response;
  }

  async getAvailableCourses(params?: {
    page?: number;
    pageSize?: number;
    name?: string;
  }): Promise<FetchResponseI<AvailableCourseI[]>> {
    return await fetchData<AvailableCourseI[]>(`${this.endpoint}/courses/available`, {
      method: 'GET',
      params,
      includePagination: true,
    });
  }

  async assignCoursesBulk(payload: BulkAssignCoursesPayload): Promise<FetchResponseI<{ success: boolean }>> {
    return await fetchData<{ success: boolean }>(`${this.endpoint}/courses/bulk`, {
      method: 'POST',
      data: payload,
    });
  }
}

const jobTitlesApi = new JobTitlesApi('/job-titles');

export default jobTitlesApi;
